import { useContext, useMemo } from 'react';
import { MultiGridContext, MultiGridContextType } from '../contexts/MultiGridContext';

export function useMultiGrid(): MultiGridContextType {
  const context = useContext(MultiGridContext);
  if (context === undefined) {
    throw new Error('useMultiGrid must be used within a MultiGridProvider');
  }

  // Defensive programming: Ensure multiGridView is always valid
  const safeContext = useMemo(() => {
    if (!context.multiGridView || 
        !Array.isArray(context.multiGridView.activeGridIds) || 
        typeof context.multiGridView.activeGridIds.includes !== 'function') {
      console.warn('useMultiGrid: Repairing corrupted multiGridView state');
      return {
        ...context,
        multiGridView: {
          activeGridIds: [],
          viewMode: 'tabs' as const
        }
      };
    }
    return context;
  }, [context]);

  return safeContext;
}